import React from "react";
import { newUser } from "../../actions/user";
import { connect } from "react-redux";
import { tempAlWait } from "../../helpers";
import { Link } from "react-router-dom/cjs/react-router-dom";

class Signup extends React.Component {
    state = {
        alert: {
            active: false,
            type: '',
            title: '',
            desc: ''
        },
        form: {
            email: '',
            mdp: '',
            mdpConf: '',
            rules: false
        },
        emailFocus: false,
        mdpFocus: false,
        mdpConfFocus: false,
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.alert != prevState.alert) {
            this.props.changeAlert(this.state.alert);
        }

        if (this.props.redNewUser != prevProps.redNewUser) {
            this.setState({
                alert: this.props.redNewUser.alert
            })
            if (this.props.redNewUser.alert.type == "succ") {
                this.props.changeStep("signin");
            }
        }
    }

    handleSubmit = (el) => {
        el.preventDefault();
        this.props.newUser({
            email: this.state.form.email,
            mdp: this.state.form.mdp,
            mdpconf: this.state.form.mdpConf,
            rules: this.state.form.rules,
        })
        this.setState({
            alert: tempAlWait()
        })
    }

    render() {
        return <div className={`signin ${this.props.otherClass != null && `signin--${this.props.otherClass}`}`}>
            <h2 className="signin__ttl">Inscription</h2>
            <form className="signin__form">
                <p className="signin__help">* champs obligatoires</p>
                {/** Email **/}
                <div
                    className="signin__inpgrp"
                    title="Assurez-vous de saisir votre adresse e-mail"
                    aria-label="Assurez-vous de saisir votre adresse e-mail"
                >
                    <label
                        htmlFor="signup-email"
                        className={`signin__lab ${(this.state.emailFocus || this.state.form.email != '') && 'signin__lab--reduce'}`}
                    >
                        E-mail *
                    </label>
                    <input
                        type="email"
                        className="signin__inp"
                        id="signup-email"
                        required
                        value={this.state.form.email}
                        onChange={(el) => {
                            this.setState(prevState => ({
                                form: {
                                    ...prevState.form,
                                    email: el.target.value
                                }
                            }))
                        }}
                        onFocus={() => this.setState({emailFocus: true})}
                        onBlur={() => this.setState({emailFocus: false})}
                    />
                </div>
                {/** Mot de passe **/}
                <div
                    className="signin__inpgrp"
                    title="Assurez-vous de saisir votre mot de passe"
                    aria-label="Assurez-vous de saisir votre mot de passe"
                >
                    <label
                        htmlFor="signup-mdp"
                        className={`signin__lab ${(this.state.mdpFocus || this.state.form.mdp != '') && 'signin__lab--reduce'}`}
                    >
                        Mot de passe *
                    </label>
                    <input
                        type="password"
                        className="signin__inp"
                        id="signup-mdp"
                        required
                        value={this.state.form.mdp}
                        onChange={(el) => {
                            this.setState(prevState => ({
                                form: {
                                    ...prevState.form,
                                    mdp: el.target.value
                                }
                            }))
                        }}
                        onFocus={() => this.setState({mdpFocus: true})}
                        onBlur={() => this.setState({mdpFocus: false})}
                    />
                </div>
                {/** Confirmation du mot de passe **/}
                <div
                    className="signin__inpgrp"
                    title="Assurez-vous de saisir la confirmation de votre mot de passe"
                    aria-label="Assurez-vous de saisir la confirmation de votre mot de passe"
                >
                    <label
                        htmlFor="signup-mdp-conf"
                        className={`signin__lab ${(this.state.mdpConfFocus || this.state.form.mdpConf != '') && 'signin__lab--reduce'}`}
                    >
                        Confirmation du mot de passe *
                    </label>
                    <input
                        type="password"
                        className="signin__inp"
                        id="signup-mdp-conf"
                        required
                        value={this.state.form.mdpConf}
                        onChange={(el) => {
                            this.setState(prevState => ({
                                form: {
                                    ...prevState.form,
                                    mdpConf: el.target.value
                                }
                            }))
                        }}
                        onFocus={() => this.setState({mdpConfFocus: true})}
                        onBlur={() => this.setState({mdpConfFocus: false})}
                    />
                </div>
                {/** Accepter le règlement **/}
                <div className="signin__inpgrpcheck">
                    <input
                        type="checkbox"
                        className="signin__inpcheck"
                        id="signup-check"
                        required
                        checked={this.state.form.rules}
                        onChange={(el) => {
                            this.setState(prevState => ({
                                form: {
                                    ...prevState.form,
                                    rules: el.target.checked
                                }
                            }))
                        }}
                    />
                    <span className="signin__inplabcheck">
                        J'accepte les <Link
                            to="/conditions-generales"
                            className="signin__inplabchecklink"
                        >conditions générales</Link>
                    </span>
                </div>
                {/** Bouton validation **/}
                <button
                    title="Créer mon compte"
                    aria-label="Créer mon compte"
                    className="signin__btn"
                    type="button"
                    onClick={(el) => this.handleSubmit(el)}
                >
                    Créer mon compte
                </button>
            </form>
            {/** Footer **/}
            <footer className="signin__ftr">
                <button
                    title="J'ai oublié mon mot de passe"
                    aria-label="J'ai oublié mon mot de passe"
                    className="signin__link"
                    onClick={() => this.props.changeStep("forgot-one")}
                >
                    Mot de passe oublié ?
                </button>
                <button
                    title="J'ai déjà un compte"
                    aria-label="J'ai déjà un compte"
                    className="signin__link"
                    onClick={() => this.props.changeStep("signin")}
                >
                    Se connecter
                </button>
            </footer>
        </div>
    }
}

const mapStateToProps = state => {
    return {
        redNewUser: state.redNewUser
    }
}

const mapDispatchToProps = {
    newUser
}

export default connect(mapStateToProps, mapDispatchToProps)(Signup);